import React, {Component} from "react";
import Search from "../Modal/Search";
import {get} from '../../utils/api';
import {fetchSearchDataSuccess} from "../../actions/searchActions";

class Headline extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record_data: {
                total: 0,
                vertical: 0,
                brand: 0
            },
            showModal: {
                search: false
            }
        };
    }
    componentDidMount() {
        get('search/creative_data').then(data => {
            let isEmpty = Object.keys(data.result).length === 0;
            if(!isEmpty){
                let sum = data.result['Live Demo Units'] + data.result['Live Banners Units'] + data.result['Mock Units'];
                this.setState({
                    record_data: {
                        total: sum,
                        vertical: data.result['verticals'],
                        brand: data.result['brand']
                    }
                })
            }
        });
    }

    toggleModal = (show, key) => {
        this.setState({
            showModal: {
                [key] : show
            }
        })
    }
    render() {
        return (
            <div className={this.props.hide ? "headline-container headline-hide" : "headline-container"}>
                {this.state.record_data.total != 0 ?
                    <h2 className="headline">Discover {this.state.record_data.total} creatives, {this.state.record_data.brand} brands, {this.state.record_data.vertical} verticals,
                        and <u onClick={e => this.toggleModal(true, 'search')}>more</u>.</h2>
                    : ""
                }
                {
                    this.state.showModal.search && <Search
                        toggleModal={this.toggleModal}
                    />
                }
            </div>
        );
    }
}


export default Headline;